import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Splash from "../components/splashScreen"
import VerifyTransaction from "../pages/VerifyTransaction";

const Home = lazy(() => import("@/pages/Home"));
const Login = lazy(() => import("@/pages/Login"));
const ForgotPassword = lazy(() => import("@/pages/ForgotPassword"));
const ResetPassword = lazy(() => import("@/pages/ResetPassword"));
const Verify = lazy(() => import("@/pages/VerifyAccount"));
const Register = lazy(() => import("@/pages/Register"));
const TrackPackage = lazy(() => import("@/pages/TrackPackage"));
const Package = lazy(() => import("@/pages/PackageHistory"));
const Dashboard = lazy(() => import("@/pages/Dashboard"));


function Routes() {
  return (
    <Router>
      <Suspense fallback={<Splash/>}>
        <Switch>
          <Route path="/login" exact component={ Login} />
          <Route path="/verify"  component={Verify} />
          <Route path="/register" exact component={ Register} />
          <Route path="/forgot-password" exact component={ ForgotPassword} />
          <Route path="/tracking" exact component={ TrackPackage} />
          <Route path="/package-detail" exact component={ Package } />
          <Route path="/verify-transaction" exact component={ VerifyTransaction } />
          <Route path="/app"   component={Dashboard} />
          <Route path="/password/reset/:id" component={ ResetPassword } />
          <Route path="/" exact component={Home} />
          {/* <Route component={Notfound} /> */}
        </Switch>
      </Suspense>
    </Router>
  );
}

export default Routes;
